export default "__VITE_ASSET__cd63a6a8__"